// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nt-container {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.nt-header-section {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}

.nt-back-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: white;
  border: 1px solid #e0e5ec;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #555;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.nt-back-btn:hover {
  background: #f8f9fa;
  border-color: #002FA7;
  color: #002FA7;
  transform: translateX(-2px);
}

.nt-back-btn:active {
  transform: translateX(0);
}

.nt-search-wrapper {
  flex: 1 1;
  max-width: 500px;
}

.nt-search-input {
  width: 100%;
  padding: 10px 16px;
  border: 1px solid #e0e5ec;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s;
  background: white;
}

.nt-search-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

/* табличный вид в строку */
.nt-list {
  width: 100%;
  border: 1px solid #e8ecf2;
  border-radius: 8px;
  overflow: hidden;
}

.nt-list-header {
  display: flex;
  background:  #002FA7;
  border-bottom: 1px solid #e8ecf2;
  font-weight: 600;
  font-size: 13px;
  color: white;
}

.nt-header-name {
  flex: 0 0 280px;
  padding: 12px 16px;
}

.nt-header-note {
  flex: 1 1;
  padding: 12px 16px;
}

.nt-header-action {
  flex: 0 0 100px;
  padding: 12px 16px;
  text-align: center;
}

.nt-list-item {
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid #f0f2f5;
  transition: background-color 0.2s;
}

.nt-list-item:last-child {
  border-bottom: none;
}

.nt-list-item:hover {
  background-color: #fafbfc;
}

.nt-list-item.has-note {
  background-color: #f4f7ff;
}

.nt-list-item.has-note:hover {
  background-color: rgba(0, 47, 167, 0.1);
}

.nt-item-name {
  flex: 0 0 280px;
  padding: 24px 16px;
  font-size: 14px;
  color: #1a1a2e;
  font-weight: 500;
  word-break: break-word;
}

.nt-item-note {
  flex: 1 1;
  padding: 10px 16px;
}

.nt-note-display {
  min-height: 44px;
  display: flex;
  align-items: center;
}

.nt-note-text {
  font-size: 13px;
  color: #333;
  line-height: 1.4;
  word-break: break-word;
  white-space: pre-wrap;
}

.nt-note-empty {
  font-size: 13px;
  color: #bbb;
  font-style: italic;
}

.nt-note-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #002FA7;
  border-radius: 6px;
  font-size: 13px;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s;
  background: white;
}

.nt-note-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 2px rgba(0, 47, 167, 0.1);
}

.nt-item-action {
  flex: 0 0 100px;
  padding: 18px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nt-action-buttons {
  display: flex;
  gap: 8px;
}

.nt-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.nt-btn-edit {
  background: #002FA7;
  color: white;
}

.nt-btn-edit:hover {
  background: #002581;
}

.nt-loading {
  text-align: center;
  padding: 40px;
  font-size: 14px;
  color: #888;
}

.nt-no-results {
  text-align: center;
  padding: 40px;
  color: #999;
  font-size: 14px;
}

.nt-btn-save {
  background: #002FA7;
  color: white;
}

.nt-btn-save:hover {
  background: #002581;
}

.nt-btn-cancel {
  background: white;
  color: #002FA7;
  border: 1px solid #002FA7;
}

.nt-btn-cancel:hover {
  background: #f4f7ff;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/md-components/NotesTeacher.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".nt-container {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.nt-header-section {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.nt-back-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: white;\n  border: 1px solid #e0e5ec;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #555;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.nt-back-btn:hover {\n  background: #f8f9fa;\n  border-color: #002FA7;\n  color: #002FA7;\n  transform: translateX(-2px);\n}\n\n.nt-back-btn:active {\n  transform: translateX(0);\n}\n\n.nt-search-wrapper {\n  flex: 1;\n  max-width: 500px;\n}\n\n.nt-search-input {\n  width: 100%;\n  padding: 10px 16px;\n  border: 1px solid #e0e5ec;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.2s;\n  background: white;\n}\n\n.nt-search-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n/* табличный вид в строку */\n.nt-list {\n  width: 100%;\n  border: 1px solid #e8ecf2;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.nt-list-header {\n  display: flex;\n  background:  #002FA7;\n  border-bottom: 1px solid #e8ecf2;\n  font-weight: 600;\n  font-size: 13px;\n  color: white;\n}\n\n.nt-header-name {\n  flex: 0 0 280px;\n  padding: 12px 16px;\n}\n\n.nt-header-note {\n  flex: 1;\n  padding: 12px 16px;\n}\n\n.nt-header-action {\n  flex: 0 0 100px;\n  padding: 12px 16px;\n  text-align: center;\n}\n\n.nt-list-item {\n  display: flex;\n  align-items: flex-start;\n  border-bottom: 1px solid #f0f2f5;\n  transition: background-color 0.2s;\n}\n\n.nt-list-item:last-child {\n  border-bottom: none;\n}\n\n.nt-list-item:hover {\n  background-color: #fafbfc;\n}\n\n.nt-list-item.has-note {\n  background-color: #f4f7ff;\n}\n\n.nt-list-item.has-note:hover {\n  background-color: rgba(0, 47, 167, 0.1);\n}\n\n.nt-item-name {\n  flex: 0 0 280px;\n  padding: 24px 16px;\n  font-size: 14px;\n  color: #1a1a2e;\n  font-weight: 500;\n  word-break: break-word;\n}\n\n.nt-item-note {\n  flex: 1;\n  padding: 10px 16px;\n}\n\n.nt-note-display {\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n}\n\n.nt-note-text {\n  font-size: 13px;\n  color: #333;\n  line-height: 1.4;\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n\n.nt-note-empty {\n  font-size: 13px;\n  color: #bbb;\n  font-style: italic;\n}\n\n.nt-note-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #002FA7;\n  border-radius: 6px;\n  font-size: 13px;\n  font-family: inherit;\n  resize: vertical;\n  transition: border-color 0.2s;\n  background: white;\n}\n\n.nt-note-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 2px rgba(0, 47, 167, 0.1);\n}\n\n.nt-item-action {\n  flex: 0 0 100px;\n  padding: 18px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.nt-action-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.nt-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n.nt-btn-edit {\n  background: #002FA7;\n  color: white;\n}\n\n.nt-btn-edit:hover {\n  background: #002581;\n}\n\n.nt-loading {\n  text-align: center;\n  padding: 40px;\n  font-size: 14px;\n  color: #888;\n}\n\n.nt-no-results {\n  text-align: center;\n  padding: 40px;\n  color: #999;\n  font-size: 14px;\n}\n\n.nt-btn-save {\n  background: #002FA7;\n  color: white;\n}\n\n.nt-btn-save:hover {\n  background: #002581;\n}\n\n.nt-btn-cancel {\n  background: white;\n  color: #002FA7;\n  border: 1px solid #002FA7;\n}\n\n.nt-btn-cancel:hover {\n  background: #f4f7ff;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
